module.exports = __webpack_public_path__ + "static/CrossPlatform-8ce1f64bed1b772a3e73085554ebdcee.svg";